import React from 'react';
import { FileText } from 'lucide-react';

const ImpressumSection = () => {
  return (
    <section
      id="impressum"
      className="py-20 px-4"
      style={{ background: 'linear-gradient(to bottom, #1A0520, #0A0015)' }}
      data-testid="impressum-section"
    >
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <FileText
            className="w-12 h-12 mx-auto mb-4 text-neon-pink animate-icon-pulse"
            style={{ filter: 'drop-shadow(0 0 10px #FF00FF)' }}
          />
          <h2
            className="text-4xl md:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Impressum
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-neon-pink to-deep-violet mx-auto rounded-full" />
        </div>

        <div
          className="glass-card p-8 text-white/80 space-y-6 leading-relaxed"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          <div>
            <h3 className="text-neon-pink font-semibold mb-1">Anbieter</h3>
            <p>Saale Lounge - Mohammad Tatou</p>
            <p>Mohammad Tatou</p>
            <p>Weihertorstraße 5 und 7</p>
            <p>97762 Hammelburg</p>
          </div>

          <div>
            <h3 className="text-neon-pink font-semibold mb-1">Kontakt</h3>
            <p>
              Telefon:{' '}
              <a
                href="tel:+491796674356"
                className="hover:text-neon-pink transition-colors"
              >
                0179 6674356
              </a>
            </p>
            <p>
              E-Mail:{' '}
              <a
                href="mailto:info.saalelounge@t-online.de"
                className="hover:text-neon-pink transition-colors"
              >
                info.saalelounge@t-online.de
              </a>
            </p>
          </div>

          <div>
            <h3 className="text-neon-pink font-semibold mb-1">
              Verantwortlich für den Inhalt
            </h3>
            <p>Mohammad Tatou</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpressumSection;
